import React from 'react';
import Navigation from '../common/Navigation';
import { POST1_IMAGES } from '../../constants/projectData';
import "../style.css";
import "./Post.css";

const Post1 = () => {
  return (
    <div>
      <Navigation />

          <div className="main-container">
                <br/>

                <div className="img-container">
                  <img src={POST1_IMAGES.main} alt="Food Delivery App" loading="lazy"/>
                </div>

                <h3>Food Delivery App</h3>

                <p>This was a project I started as my very first frontend project when I first learned HTML, CSS AND JavaScript. I was the sole creator/developer for the of the project.
                <br/><br/>
                The system stored sample data for the restraunts search and provided all the data about a particular restraunt  and admins to view, add and send data to clients.
                <br/><br/>
                search results would be generated by the fetching the data from the API  and the sytem had location based filters and category based filters interface for customers to be able to login and view.
                <br/><br/>
                Customers had the ability to view all their data with a dynamic search form, trend data.
                <br/><br/>
                I completed this project within 24hours of time , and i was really happy after completing my very first project.</p>

                <h5>Technologies:</h5>

                <ul>
                      <li>- HTML</li>
                      <li>- CSS</li>
                      <li>- JavaScript</li>
                      <li>- BootStrap</li>
                      <li>- Font Awesome Icons</li>
                      <li>- Hotel Api</li>
                      <li>- Google Fonts</li>
                </ul>

                <h5>Restaurants on the basis of Types</h5>
                <div className="img-container">
                  <img src={POST1_IMAGES.types} alt="Restaurant Types" loading="lazy"/>
                </div>

                <h5>APP Store</h5>
                <div className="img-container">
                  <img src={POST1_IMAGES.appStore} alt="App Store" loading="lazy"/>
                </div>

                <h5>All Locations</h5>
                <div className="img-container">
                  <img src={POST1_IMAGES.locations} alt="All Locations" loading="lazy"/>
                </div>

                <h5>About Page</h5>
                <div className="img-container">
                  <img src={POST1_IMAGES.about} alt="About Page" loading="lazy"/>
                </div>

                <h5>Vision Page</h5>
                <div className="img-container">
                  <img src={POST1_IMAGES.footer} alt="Vision Page" loading="lazy"/>
                </div>
          </div>
    </div>
    )
}

export default Post1
